// Deactivate Code Bulk
export const DEACTIVATE_CODE_BULK_REQUEST = 'DEACTIVATE_CODE_BULK_REQUEST';
export const DEACTIVATE_CODE_BULK_DONE = 'DEACTIVATE_CODE_BULK_DONE';
export const DEACTIVATE_CODE_BULK_FAILED = 'DEACTIVATE_CODE_BULK_FAILED';
